import React, { useState, useEffect } from 'react';
import { Search, User, ShoppingBag, Phone, LogOut } from 'lucide-react';
import { Chip, Grid, Card, CardContent, Typography, CardMedia, Button, Box, IconButton, FormGroup, FormControlLabel, Checkbox, CircularProgress } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft.js';
import ChevronRightIcon from '@mui/icons-material/ChevronRight.js';
import AddIcon from '@mui/icons-material/Add.js';
import RemoveIcon from '@mui/icons-material/Remove.js';
import backgroundImage from '../../../assets/backgroundImage.png';
import AllCategorySideImage from '../../../assets/Frame.svg';
import VisibilityIcon from '@mui/icons-material/Visibility.js';
import bag from '../../../assets/bag-2.svg';
import ScrollContainer from '../../../components/ScrollContainer.js';
import ProductDetails from './ProductDetails.js';
import StoreBannerSlider from './StoreBannerSlider.js';
import { Row, Col } from 'reactstrap';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline.js';

// Local Banner Assets
import banner1 from '../../../assets/images/banner_1.jpg';
import banner2 from '../../../assets/images/banner_2.jpg';
import banner3 from '../../../assets/images/banner_3.jpg';

const localBanners = [
  {
    Image: [banner1],
    badge: 'IPHrx',
    title: 'The place where you can',
    highlight: 'find all medications',
    description: 'It is a long established fact that a reader will be distracted readable content of a page when looking at its layout.',
    sideImage: AllCategorySideImage
  },
  {
    Image: [banner2],
    badge: 'HEALTH',
    title: 'Your wellness is our',
    highlight: 'top priority',
    description: 'We provide a wide range of essential medications and healthcare products to keep you healthy.',
    sideImage: AllCategorySideImage
  },
  {
    Image: [banner3],
    badge: 'CARE',
    title: 'Professional advice and',
    highlight: 'expert care',
    description: 'Our experienced pharmacists are here to provide you with the best pharmaceutical guidance.',
    sideImage: AllCategorySideImage
  },
];

// MainCategoriesBanner Component
const MainCategoriesBanner = ({ banners }) => (
  <>
    {/* <Box
      sx={{
        backgroundImage: `linear-gradient(to right, rgba(255,255,255,0.7), rgba(255,255,255,0.6)), url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: {
          xs: '40px 20px 200px', // Increased bottom padding for mobile to accommodate icons
          sm: '80px 20px',
          md: '130px 20px'
        },
        marginTop: { xs: '20px', sm: '25px', md: '30px' },
        marginBottom: { xs: '20px', sm: '25px', md: '30px' },
        width: '100%',
        position: 'relative',
        overflow: 'hidden',
        minHeight: { xs: 'auto', sm: '450px', md: '530px' }
      }}
    >
      // Left Content
      <Box sx={{
        maxWidth: '1300px',
        margin: '0 auto',
        position: 'relative',
        zIndex: 2,
      }}>
        <Box
          sx={{
            backgroundColor: '#5190A6',
            color: 'white',
            padding: { xs: '3px 10px', sm: '4px 12px' },
            borderRadius: '4px',
            display: 'inline-block',
            marginBottom: { xs: '20px', sm: '10px' },
            fontSize: { xs: '12px', sm: '14px' }
          }}
        >
          IPHrx
        </Box>
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: '32px', sm: '36px', md: '48px' },
            color: '#5190A6',
            margin: { xs: '15px 0', sm: '20px 0' },
            maxWidth: { xs: '100%', sm: '80%', md: '600px' },
            lineHeight: 1.2,
            fontWeight: 500,
            '& .highlight': {
              color: '#333333', // Dark color for "find all medications"
              display: { xs: 'block', sm: 'inline' } // Stack on mobile
            }
          }}
        >
          The place where you can{' '}
          <span className="highlight">find all medications</span>
        </Typography>
        <Typography
          sx={{
            color: '#666',
            fontSize: { xs: '14px', sm: '15px', md: '16px' },
            maxWidth: { xs: '100%', sm: '70%', md: '500px' },
            lineHeight: 1.6,
            mt: { xs: 2, sm: 3 }
          }}
        >
          It is a long established fact that a reader will be distracted readable content of a page when looking at its layout.
        </Typography>
      </Box>

      // Medical Icons - Repositioned for mobile
      <Box
        sx={{
          position: 'absolute',
          bottom: { xs: '20px', md: '50%' },
          right: { xs: '50%', md: '5%', lg: '10%' },
          transform: {
            xs: 'translateX(50%)',
            md: 'translateY(50%)'
          },
          width: { xs: '280px', md: '300px', lg: '400px' },
          height: 'auto',
          display: 'block', // Always show on mobile
          zIndex: 1
        }}
      >
        <img
          src={AllCategorySideImage}
          alt="Medical Icons"
          style={{
            width: '100%',
            height: 'auto'
          }}
        />
      </Box>
    </Box> */}

    <StoreBannerSlider banners={banners && banners.length > 0 ? banners : localBanners} />

  </>
);

// Product Grid Component
const ProductGrid = ({ products, handleIncrement, handleDecrement, handleAddToCart, getProductQuantity, handleVariationChange, tempCart, setProduct_Details, productStock, syncCartNow }) => (
  <ScrollContainer>
    <Box sx={{
      display: 'grid',
      gridTemplateColumns: {
        xs: '1fr',
        sm: 'repeat(2, 1fr)',
        md: 'repeat(3, 1fr)',
        lg: 'repeat(4, 1fr)'
      },
      gap: { xs: '15px', sm: '20px' },
      padding: { xs: '15px', sm: '20px' },
      maxWidth: '1300px',
      margin: '0 auto'
    }}>
      {products.map((product, index) => (
        <ProductCard
          key={index}
          setProduct_Details={setProduct_Details}
          product={product}
          handleAddToCart={handleAddToCart}
          handleIncrement={handleIncrement}
          handleDecrement={handleDecrement}
          getProductQuantity={getProductQuantity}
          handleVariationChange={handleVariationChange}
          tempCart={tempCart}
          productStock={productStock}

          syncCartNow={syncCartNow}
        />
      ))}
    </Box>
  </ScrollContainer>
);

const ProductCard = ({ product, getProductQuantity, handleAddToCart, setProduct_Details, handleVariationChange, tempCart, handleIncrement, handleDecrement, productStock, syncCartNow }) => {
  let Quantity = getProductQuantity(product._id);
  const [quantity, setQuantity] = useState(() => getProductQuantity(product._id));
  const productInCart = tempCart.some(item => item.product_id === product._id); // Check if product is in cart
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setQuantity(getProductQuantity(product._id));
  }, [product._id, tempCart]);

  const handleLocalIncrement = () => {
    // Check if adding one more would exceed available stock
    if (productStock && productStock[product._id] > quantity) {
      const newQuantity = quantity + 1;
      setQuantity(newQuantity);
    } else {
      // Show stock warning only when trying to exceed limit
      if (productStock && productStock[product._id] !== undefined) {
        //iph todo: 47
        //console.log(`Local increment stock limit reached: ${productStock[product._id]} items available`);
        // Don't show warning here since handleAddToCart will handle it
      }
    }
  };

  const handleLocalDecrement = () => {
    const newQuantity = quantity > 0 ? quantity - 1 : 0;
    setQuantity(newQuantity);
  };

  // Check if product is available in stock
  const isProductInStock = productStock && productStock[product._id] > 0;
  const availableStock = productStock && productStock[product._id] ? productStock[product._id] : 0;

  // Helper function to show stock warning
  const showStockWarning = () => {
    if (productStock && productStock[product._id] !== undefined && productStock[product._id] <= 0) {
      return true;
    }
    return false;
  };

  const ViewProductDetails = (product) => {
    setProduct_Details(product);
  };

  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 2,
        overflow: 'hidden',
        position: 'relative',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        opacity: productStock && productStock[product._id] === 0 ? 0.7 : 1,
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: productStock && productStock[product._id] > 0 ? 'translateY(-2px)' : 'none',
          boxShadow: productStock && productStock[product._id] > 0 ? '0 4px 12px rgba(0, 0, 0, 0.15)' : '0 2px 8px rgba(0, 0, 0, 0.1)',
        },
      }}
    >
      {/* Product Information */}
      <CardContent sx={{ p: 2 }}>
        <Typography variant="subtitle2" color="#3488A4" fontSize="12px">
          {product?.CategoryDetails?.[0]?.Name}
        </Typography>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            color: '#5190A6',
            cursor: 'pointer',
            display: '-webkit-box',
            '-webkit-line-clamp': 2,
            '-webkit-box-orient': 'vertical',
            fontSize: '14px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '100%',
            lineHeight: 1.4,
            minHeight: '40px' // Ensure visual consistency even with 1 line
          }}
          onClick={() => ViewProductDetails(product)}
          title={product.item_name}
        >
          {product.item_name}
        </Typography>
        <Typography variant="body2" color="#666" fontSize="12px">
          {product?.BaseUOM || '(150mg + 100mg)'}
        </Typography>

        {/* Stock Status Display - fixed height to keep card layouts aligned */}
        <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 1, minHeight: 22 }}>
          {productStock && productStock[product._id] !== undefined ? (
            productStock[product._id] === 0 ? (
              <Typography
                variant="body2"
                sx={{
                  color: '#dc3545',
                  fontSize: '11px',
                  fontWeight: 'bold',
                  backgroundColor: '#f8d7da',
                  padding: '2px 6px',
                  borderRadius: '4px',
                  border: '1px solid #dc3545',
                  whiteSpace: 'nowrap',
                  lineHeight: '18px'
                }}
              >
                Out of Stock
              </Typography>
            ) : productStock[product._id] < 30 ? (
              <Typography
                variant="body2"
                sx={{
                  color: '#ff6b35',
                  fontSize: '11px',
                  fontWeight: 'bold',
                  backgroundColor: '#fff3e0',
                  padding: '2px 6px',
                  borderRadius: '4px',
                  border: '1px solid #ff6b35',
                  whiteSpace: 'nowrap',
                  lineHeight: '18px'
                }}
              >
                Limited stock
              </Typography>
            ) : (
              // Render empty space to reserve height when no badge
              <Box sx={{ height: 22 }} />
            )
          ) : (
            // Also reserve space while stock is loading
            <Box sx={{ height: 22 }} />
          )}
        </Box>

        {/* Stock Warning Message */}
        {productStock && showStockWarning() && (
          <Typography
            variant="body2"
            sx={{
              color: '#dc3545',
              fontSize: '10px',
              fontStyle: 'italic',
              mt: 0.5,
              textAlign: 'center'
            }}
          >
          </Typography>
        )}
      </CardContent>

      {/* Product Image */}
      <Box sx={{ position: 'relative' }}>
        {product.discount && (
          <Chip
            label={`-${product.discount}%`}
            color="primary"
            sx={{
              position: 'absolute',
              top: 10,
              right: 10,
              backgroundColor: 'rgba(81, 144, 166, 0.9)',
              color: 'white',
              borderRadius: '12px',
              fontSize: '12px',
              fontWeight: 'bold',
              padding: '2px 8px',
              zIndex: 2,
            }}
          />
        )}



        <CardMedia
          onClick={() => ViewProductDetails(product)}
          component="img"
          height="200"
          width={20}
          image={product.Images?.[0] || "/placeholder.svg"}
          alt={product.item_name}
          sx={{ objectFit: 'cover', p: 1, cursor: 'pointer' }}
        />
      </Box>

      {/* Quantity and Variations */}
      <CardContent sx={{ flexGrow: 1, p: 2 }}>
        {/* <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            border: '1px solid #EEEEEE',
            borderRadius: '12px',
            p: 1,
            mb: 2,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconButton
              onClick={handleDecrement}
              size="small"
              disabled={quantity === 0}
              sx={{ border: '1px solid #5190A6', color: '#5190A6' }}
            >
              <RemoveIcon sx={{ fontSize: '12px' }} />
            </IconButton>
            <Typography sx={{ fontSize: '13px', mx: 1 }}>{quantity.toString().padStart(2, '0')}</Typography>
            <IconButton
              onClick={handleIncrement}
              size="small"
              sx={{ border: '1px solid #5190A6', color: '#5190A6' }}
            >
              <AddIcon sx={{ fontSize: '12px' }} />
            </IconButton>
          </Box>
        </Box> */}

        {/* Show Variations Only if Product is in Cart */}
        {productInCart && product.GroupedVariations && product?.GroupedVariations.length > 0 && (
          <CardContent>
            <Typography variant="subtitle2" sx={{ fontWeight: 'medium', mb: 1, fontSize: '12px' }}>Variations:</Typography>
            {product.GroupedVariations.map((variationGroup) => (
              <Box key={variationGroup.Variation._id} sx={{ mb: 1 }}>
                <Typography variant="body2" fontSize="12px">{variationGroup.Variation.name}</Typography>
                <FormGroup row>
                  {variationGroup.VariationTypes.map((type) => (
                    <FormControlLabel
                      key={type._id}
                      control={
                        <Checkbox
                          size="small"
                          onChange={(e) => handleVariationChange(product, variationGroup, type, e.target.checked)}
                          checked={tempCart.some(item =>
                            item.product_id === product._id &&
                            item.variations.some(v =>
                              v.variation_id === variationGroup.Variation._id &&
                              v.variation_option_id === type._id
                            )
                          )}
                        />
                      }
                      label={<Typography variant="body2" fontSize="12px">{type.variation_type_name} (RM{parseFloat(type.price).toFixed(2)})</Typography>}
                    />
                  ))}
                </FormGroup>
              </Box>
            ))}
          </CardContent>
        )}

        {/* Cart Controls */}
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <IconButton
            onClick={() => ViewProductDetails(product)}
            size="small"
            sx={{
              border: '1px solid #5190A6',
              color: '#5190A6',
              '&:hover': {
                backgroundColor: '#f5f5f5',
              },
            }}
          >
            <VisibilityIcon sx={{ fontSize: '12px' }} />
          </IconButton>

          {quantity === 0 ? (
            <Box
              onClick={async () => {
                // Check if product is in stock before adding to cart
                if (productStock && productStock[product._id] > 0) {
                  try { setIsSaving(true); await handleAddToCart(product, 1, true); } finally { setIsSaving(false); }
                } else {
                  // Optional: Show alert when trying to add out-of-stock item
                  //iph todo: 47
                  //console.log(`Cannot add ${product.item_name} - Out of stock`);
                }
              }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: productStock && productStock[product._id] > 0 ? '#5190A6' : '#6c757d',
                color: 'white',
                borderRadius: '999px',
                padding: '8px 14px',
                minWidth: 110,
                gap: 1,
                cursor: productStock && productStock[product._id] > 0 ? 'pointer' : 'not-allowed',
                opacity: productStock && productStock[product._id] > 0 ? 1 : 0.5,
                transition: 'all 0.2s ease',
                boxShadow: '0 6px 12px rgba(0,0,0,.08)',
                '&:hover': {
                  backgroundColor: productStock && productStock[product._id] > 0 ? '#457A8F' : '#6c757d',
                  transform: productStock && productStock[product._id] > 0 ? 'translateY(-1px)' : 'none',
                },
                '&:active': {
                  transform: productStock && productStock[product._id] > 0 ? 'translateY(0px)' : 'none',
                },
              }}
            >
              {isSaving ? (
                <CircularProgress size={16} sx={{ color: 'white' }} />
              ) : (
                <>
                  <Box component="img" src={bag} alt="Cart" sx={{ width: '16px', height: '16px' }} />
                  <Typography variant="body2" fontWeight="bold" fontSize="12px">
                    {productStock && productStock[product._id] > 0 ? 'Add to cart' : 'Out of Stock'}
                  </Typography>
                </>
              )}
              <Typography variant="body2" fontWeight="bold" fontSize="12px">
                RM{parseFloat(product.price).toFixed(2)}
              </Typography>
            </Box>
          ) : (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, width: '100%', flexWrap: 'nowrap' }}>
              {/* Quantity Controls */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  border: '1px solid #d9e4ea',
                  borderRadius: '999px',
                  backgroundColor: '#fff',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
                  flex: '0 1 auto'
                }}
              >
                <IconButton
                  onClick={handleLocalDecrement}
                  size="small"
                  sx={{
                    color: '#5190A6',
                    minWidth: 34,
                    height: 34,
                    borderRadius: '999px 0 0 999px',
                    '&:hover': {
                      backgroundColor: '#f5f9fb',
                    },
                  }}
                >
                  <RemoveIcon sx={{ fontSize: '16px' }} />
                </IconButton>
                <Typography
                  sx={{
                    fontSize: 13,
                    fontWeight: 'bold',
                    color: '#5190A6',
                    minWidth: 42,
                    textAlign: 'center',
                    borderLeft: '1px solid #d9e4ea',
                    borderRight: '1px solid #d9e4ea',
                    padding: '6px 10px',
                  }}
                >
                  {quantity}
                </Typography>
                <IconButton
                  onClick={() => {
                    // Check if adding one more would exceed available stock
                    if (productStock && productStock[product._id] > quantity) {
                      handleLocalIncrement();
                    } else {
                      // Optional: Show message when trying to exceed stock limit
                      //iph todo: 47
                      //console.log(`Cannot add more ${product.item_name} - Stock limit reached (${productStock ? productStock[product._id] : 0} available)`);
                    }
                  }}
                  size="small"
                  disabled={!productStock || productStock[product._id] <= quantity}
                  sx={{
                    color: productStock && productStock[product._id] > quantity ? '#5190A6' : '#9aa7ad',
                    minWidth: 34,
                    height: 34,
                    borderRadius: '0 999px 999px 0',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      backgroundColor: productStock && productStock[product._id] > quantity ? '#f5f9fb' : 'transparent',
                    },
                    '&:disabled': {
                      opacity: 0.5,
                      cursor: 'not-allowed'
                    }
                  }}
                >
                  <AddIcon sx={{ fontSize: '16px' }} />
                </IconButton>
              </Box>

              {/* Add and Remove Buttons (API sync only on these) */}
              <Box onClick={async () => { try { setIsSaving(true); await handleAddToCart(product, quantity, true); } finally { setIsSaving(false); } }}
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#5190A6',
                  color: '#fff',
                  borderRadius: '999px',
                  height: 32,
                  padding: '0 18px',
                  minWidth: 80,
                  cursor: 'pointer',
                  boxShadow: '0 6px 12px rgba(0,0,0,.08)',
                  '&:hover': { backgroundColor: '#457A8F' },
                  whiteSpace: 'nowrap',
                  flexShrink: 0
                }}>
                {isSaving ? <CircularProgress size={16} sx={{ color: '#fff' }} /> : <Typography variant="body2" fontWeight="bold" fontSize="12px">Add</Typography>}
              </Box>
              <IconButton onClick={async () => { try { setIsSaving(true); await handleAddToCart(product, 0, true); } finally { setIsSaving(false); } }}
                size="small"
                sx={{
                  color: '#dc3545',
                  borderRadius: '999px',
                  height: 32,
                  width: 32,
                  minWidth: 32,
                  border: '1px solid #f1c2c7',
                  backgroundColor: '#fff',
                  '&:hover': { backgroundColor: '#fff5f6' },
                  flexShrink: 0
                }}
              >
                <DeleteOutlineIcon sx={{ fontSize: 18 }} />
              </IconButton>
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

// CategoryBanner Component
const CategoryBanner = ({ category }) => (
  <Box
    sx={{
      backgroundImage: `linear-gradient(to right, rgba(255,255,255,0.7), rgba(255,255,255,0.6)), url(${backgroundImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      padding: { xs: '60px 15px', sm: '70px 20px', md: '80px 20px' },
      marginTop: { xs: '20px', sm: '25px', md: '30px' },
      marginBottom: { xs: '20px', sm: '25px', md: '30px' },
      width: '100%',
      minHeight: { xs: '250px', sm: '275px', md: '300px' }
    }}
  >
    <Box sx={{ maxWidth: '1300px', margin: '0 auto' }}>
      <Box
        sx={{
          backgroundColor: '#5190A6',
          color: 'white',
          padding: { xs: '3px 10px', sm: '4px 12px' },
          borderRadius: '4px',
          display: 'inline-block',
          marginBottom: { xs: '8px', sm: '10px' },
          fontSize: { xs: '12px', sm: '14px' }
        }}
      >
        IPHrx
      </Box>
      <Typography
        variant="h1"
        sx={{
          fontSize: { xs: '28px', sm: '32px', md: '36px' },
          color: '#5190A6',
          marginTop: { xs: '20px', sm: '25px', md: '30px' },
          margin: '10px 0',
          textAlign: 'center'
        }}
      >
        {category?.Name || 'All Categories'}
      </Typography>
      <Typography
        sx={{
          color: '#666',
          fontSize: { xs: '12px', sm: '13px', md: '14px' },
          textAlign: 'center'
        }}
      >
        Home {">"} {category?.Name}
      </Typography>
    </Box>
  </Box>
);

// Main Content Component
const CategoryContent = ({
  searchTerm,
  categories,
  activeCategory,
  categorizedProducts,
  handleIncrement,
  handleDecrement,
  getProductQuantity,
  handleCategoryClick,
  handleVariationChange,
  tempCart,
  setProduct_Details,
  setShowLoginPopup,
  productDetails,
  handleAddToCart,
  banners,
  productStock,
  syncCartNow
}) => {
  // Filter categories to exclude those with an empty name or no products
  categories = categories.filter(category =>
    category?.Name !== '' &&
    categorizedProducts[category._id]?.length > 0
  );

  const selectedCategory = categories.find(cat => cat._id === activeCategory);

  // Helper function to get products based on current view state
  const getDisplayProducts = () => {
    if (searchTerm) {
      if (activeCategory) {
        return Array.isArray(categorizedProducts)
          ? categorizedProducts.filter(product => product.category === activeCategory)
          : [];
      }
      return Array.isArray(categorizedProducts) ? categorizedProducts : [];
    }

    if (activeCategory && categorizedProducts[activeCategory]) {
      return categorizedProducts[activeCategory];
    }

    if (!activeCategory) {
      return Object.values(categorizedProducts).flat();
    }

    return [];
  };

  const displayProducts = getDisplayProducts();

  return (
    <>
      {productDetails !== null ? (
        <ProductDetails
          product={productDetails}
          handleAddToCart={handleAddToCart}
          setShowLoginPopup={setShowLoginPopup}
          ProductGrid={ProductGrid}
          setProduct_Details={setProduct_Details}
          products={displayProducts}
          handleIncrement={handleIncrement}
          handleDecrement={handleDecrement}
          getProductQuantity={getProductQuantity}
          tempCart={tempCart}
          handleVariationChange={handleVariationChange}
          productStock={productStock}
        />
      ) : (
        <>
          {activeCategory ? (
            <CategoryBanner category={selectedCategory} />
          ) : (
            <MainCategoriesBanner banners={banners} />
          )}

          {displayProducts.length === 0 ? (
            <Box sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '200px',
              padding: '20px'
            }}>
              <Typography variant="h6" color="text.secondary">
                {searchTerm ? 'No products found matching your search.' : 'No products available in this category.'}
              </Typography>
            </Box>
          ) : (
            <ProductGrid
              setProduct_Details={setProduct_Details}
              handleAddToCart={handleAddToCart}
              products={displayProducts}
              handleIncrement={handleIncrement}
              handleDecrement={handleDecrement}
              getProductQuantity={getProductQuantity}
              tempCart={tempCart}
              handleVariationChange={handleVariationChange}
              productStock={productStock}
              syncCartNow={syncCartNow}
            />
          )}
        </>
      )}
    </>
  );
};




export {
  CategoryBanner,
  ProductGrid,
  ProductCard,
  CategoryContent
};